import React, { useState } from 'react';
import { Box, Button, Container, Grid, TextField, Typography } from '@mui/material';
import styled from 'styled-components';
import { Controller, useForm } from 'react-hook-form';
import Swal from 'sweetalert2';
import ApiService from '../../helpers/ApiService';
import { CTA } from '../Common/CTA';
import { useDrawer } from '../../providers/DrawerProvider';

const FormForgotPasswordContainer = styled.div`
  form {
    .MuiInputBase-root {
      color: var(--bluegray-600);
      background-color: var(--white);
    }
    .MuiFormHelperText-root {
      color: var(--bluegray-400);
    }
    .MuiFormControlLabel-label  {
      color: var(--white);
    }

    hr {
      border: none;
      border-top: 1px solid rgba(0, 0, 0, 0.2);
      margin: 1rem 5rem;
    }
  }
`;

export const FormForgotPass = () => {
  const { setFormPanel, setEmailToRecoverPass } = useDrawer()
  const { handleSubmit, control } = useForm();
  const [ isLoading, setIsLoading ] = useState(false);
  
  const onSave = async data => {
    setIsLoading(true);

    ApiService.post('user/request-code', data).then(( result ) => {
      if ( result.status === 200 ) {
        setEmailToRecoverPass(data.email);
        Swal.fire({
          icon: 'success',
          title: `E-mail enviado`,
          text: `Foi enviado o código para redefinição de sua senha.`,
          confirmButtonText: 'Ok, obrigado!'
        });
        setIsLoading(false);
        setFormPanel('recoverPassword');
      }
    })
    .catch( (error) => {
      let errorIcon = 'error';
      let errorTitle = 'Oops...';
      let errorText = 'Ocorreu um erro desconhecido. Tente novamente mais tarde.';
      let errorButton = 'Entendi';

      if ( error && error.status === 400 ) {
        errorIcon = 'info';
        errorTitle = 'Código ainda válido';
        errorText = 'O código foi enviado recentemente e ainda é válido para redefinição de sua senha. Se ainda não recebeu o e-mail, aguarde alguns minutos e tente novamente.';
        errorButton = "Redefinir senha";
        setEmailToRecoverPass(data.email);
        setFormPanel('recoverPassword');
      }
      if ( error && error.status === 404 ) {
        errorTitle = 'Usuário não encontrado';
        errorText = 'Não foi encontrado nenhum usuário utilizando este e-mail. Por favor, verifique o endereço digitado.';
        errorButton = "Verificar";
      }
      
      Swal.fire({
        icon: errorIcon,
        title: errorTitle,
        text: errorText,
        confirmButtonText: errorButton
      });

      setIsLoading(false);
    });
  }

  return (
    <FormForgotPasswordContainer>
      <Container>
        <form onSubmit={handleSubmit(onSave)}>
        <Grid container spacing={1}>
            <Grid item sm={12} xs={12} align="center">
              <Box mt={4} mb={2}>
                <Typography variant="body1" className="middle--text">
                  Informe seu e-mail que deseja lembrar a senha
                </Typography>
              </Box>
            </Grid>
            <Grid item sm={12} xs={12}>
              <Controller
                name="email"
                control={control}
                defaultValue=""
                render={ ({ field: { onChange, value }, fieldState: { error } }) => (
                  <TextField
                    id='emailRegister'
                    type="email"
                    label="Insira seu e-mail"
                    placeholder="Insira seu e-mail"
                    variant="outlined"
                    fullWidth
                    value={value}
                    onChange={(e) => onChange(String(e.target.value).toLowerCase())}
                    error={!!error}
                    helperText={error ? "E-mail inválido" : null}
                  />
                )}
                rules={{ required: 'E-mail obrigatório', pattern: /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/ }}
                register
              />
            </Grid>
            <Grid item sm={12} xs={12} align="center" mt={2}>
              <CTA type="submit" disabled={isLoading}>
                Lembrar senha
              </CTA>
            </Grid>
            <Grid item sm={12} xs={12} align='center'>
              <Button
                variant="text"
                className="middle--text small-text initial"
                size='small'
                onClick={() => setFormPanel('recoverPassword') }
              >
                Já possuo o código
              </Button>
            </Grid>
            <Grid item sm={12} xs={12} align="center">
              <hr />
              <Box mb={4}>
                <Typography variant="body1" className="dark--text" gutterBottom>
                  Lembrou? <span className="bold-text button-text" onClick={ () => setFormPanel('login') }>Faça seu login</span>
                </Typography>
              </Box>
            </Grid>
          </Grid>
        </form>
      </Container>
    </FormForgotPasswordContainer>
  )
}

export default FormForgotPass;